<template>
  <b-container fluid id="chartContainer" style="margin-bottom: 20px">
    <b-row style="margin-bottom: 20px;">
      <b-container fluid>
        <GChart
            type="LineChart"
            :data="addFrostHeaders(waterChartData)"
            :options="getFrostOptions(1)"

        />
        <GChart
            type="LineChart"
            :data="addIrrigationHeaders(waterChartData)"
            :options="getIrrigationOptions(1)"

        />

        <GChart
            type="LineChart"
            :data="addTastingHeaders(waterChartData)"
            :options="getTastingOptions(1)"

        />

        <GChart
            type="LineChart"
            :data="addOther2Headers(waterChartData)"
            :options="getOther2Options(1)"

        />
      </b-container>
    </b-row>
    <b-row>
      <b-container fluid>
        <GChart
            type="LineChart"
            :data="addSolarHeaders(powerData)"
            :options="getSolarOptions(1)"

        />
        <GChart
            type="LineChart"
            :data="addElectricMeter1Headers(powerData)"
            :options="getElectricOptions(1, 'orange')"

        />

        <GChart
            type="LineChart"
            :data="addElectricMeter2Headers(powerData)"
            :options="getElectricOptions(2,'gray')"

        />


        <GChart
            type="LineChart"
            :data="addElectricMeter3Headers(powerData)"
            :options="getElectricOptions(3,'purple')"

        />
      </b-container>
    </b-row>
    <b-row>
      <b-container fluid>
        <GChart
            type="LineChart"
            :data="addGasHeaders(gasData)"
            :options="getNaturalGasOptions('tan')"

        />
        <GChart
            type="LineChart"
            :data="addPropaneHeaders(gasData)"
            :options="getPropaneOptions(1, 'darkgrey')"

        />
        <GChart
            type="LineChart"
            :data="addGasolineHeaders(gasData)"
            :options="getGasolineOptions(1, 'darkgreen')"

        />
      </b-container>
    </b-row>
    <b-row>
      <b-container fluid>
        <GChart
            type="LineChart"
            :data="addHeadersDynamic(fertilizerData,'Solid Fertilizer','solid')"
            :options="getDynamicOptions('Solid Fertilizer - Lbs/Month', 'tan','solid')"

        />
        <GChart
            type="LineChart"
            :data="addHeadersDynamic(fertilizerData,'Liquid Fertilizer','liquid')"
            :options="getDynamicOptions('Liquid Fertilizer - Gallons/Month', 'yellow','liquid')"

        />
        <GChart
            type="LineChart"
            :data="addHeadersDynamic(fertilizerData, 'Compost','compost')"
            :options="getDynamicOptions('Compost - Tons/Month', 'red','compost')"

        />
        <GChart
            type="LineChart"
            :data="addHeadersDynamic(fertilizerData,'Manure','manure')"
            :options="getDynamicOptions('Manure - Tons/Month', 'brown','manure')"

        />
      </b-container>
    </b-row>
    <b-row>
      <b-col cols="12">
        <VineyardSimplePowerMetricTable :groupId="theGroup"></VineyardSimplePowerMetricTable>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <VineyardSimpleGasMetricTable :groupId="theGroup"></VineyardSimpleGasMetricTable>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <VineyardSimpleWaterMetricTable :groupId="theGroup"></VineyardSimpleWaterMetricTable>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <VineyardSimpleFertilizerMetricTable :groupId="theGroup"></VineyardSimpleFertilizerMetricTable>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {GChart} from 'vue-google-charts'
import ElectricMetricTable from "@/components/ElectricMetricTable";
import WaterMetricTable from "@/components/WaterMetricTable";
import VineyardSimplePowerMetricTable from "@/components/vineyard/metrics/graph/VineyardSimplePowerMetricTable"
import VineyardSimpleGasMetricTable from "@/components/vineyard/metrics/graph/VineyardSimpleGasMetricTable"
import VineyardSimpleWaterMetricTable from "@/components/vineyard/metrics/graph/VineyardSimpleWaterMetricTable";
import VineyardSimpleFertilizerMetricTable
  from "@/components/vineyard/metrics/graph/VineyardSimpleFertilizerMetricTable";

Date.shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];


export default {
  name: "VineyardResourceGraphs",
  components: {
    ElectricMetricTable,
    GChart,
    WaterMetricTable,
    VineyardSimplePowerMetricTable,
    VineyardSimpleGasMetricTable,
    VineyardSimpleWaterMetricTable,
    VineyardSimpleFertilizerMetricTable
  },
  props: {
    groupId: String
  },
  beforeRouteLeave(to, _from, next) {
    if (to.name === "TabbedMetrics" && Object.keys(to.params).length === 0) {
      next({name: "TabbedMetrics", params: {groupId: this.theGroup}})
    } else if (to.name === "Metrics Summary" && Object.keys(to.params).length === 0) {
      next({name: "Metrics Summary", params: {groupId: this.theGroup}})
    } else {
      next()
    }

  },
  data() {
    return {
      showGasInfo: false,
      electricRows: {},
      waterRows: {},
      powerData: [],
      waterData: [],
      gasData: [],
      fertilizerData: [],
      propaneData: [],
      waterChartData: [],
      theGroup: this.groupId || localStorage.getItem('adminImpersonationGroupId') || localStorage.getItem('groupId'),
      chartHeight: '70%',
      chartWidth: '70%',
      chartWrapperHeight: 500,
      chartWrapperWidth: '90%',
      fullMonthList: []
    }
  },
  computed: {
    frostMax: function () {
      return this.calculateMaxChartYValue(this.waterChartData, 'frost');
    },
    solarMax: function () {
      return this.calculateMaxChartYValue(this.powerData, 'solar');
    },
    agMax: function () {
      return this.calculateMaxChartYValue(this.powerData, 'ag');
    },
    ag1Max: function () {
      return this.calculateMaxChartYValue(this.powerData, 'ag1');
    },
    ag2Max: function () {
      return this.calculateMaxChartYValue(this.powerData, 'ag2');
    },
    ag3Max: function () {
      return this.calculateMaxChartYValue(this.powerData, 'ag3');
    },//wineryProcess
    processMax: function () {
      return this.calculateMaxChartYValue(this.waterChartData, 'irrigation');
    },
    wasteWaterMax: function () {
      return this.calculateMaxChartYValue(this.waterChartData, 'other2');//'wastewater');
    },
    otherMax: function () {
      return this.calculateMaxChartYValue(this.waterChartData, 'other');
    },
    other2Max: function () {
      return this.calculateMaxChartYValue(this.waterChartData, 'other2');
    },
    propaneMax: function () {
      return this.calculateMaxChartYValue(this.gasData, 'propaneMeter');
    },
    gasolineMax: function () {
      return this.calculateMaxChartYValue(this.gasData, 'gasoline');
    },
    solidMax: function () {
      return this.calculateMaxChartYValue(this.fertilizerData, 'solid');
    },
    liquidMax: function () {
      return this.calculateMaxChartYValue(this.fertilizerData, 'liquid');
    },
    compostMax: function () {
      return this.calculateMaxChartYValue(this.fertilizerData, 'compost');
    },
    manureMax: function () {
      return this.calculateMaxChartYValue(this.fertilizerData, 'manure');
    }
  },
  mounted() {
    this.fullMonthList = this.calculateMonthList();
    this.$http.get("metrics/vineyard/water/graph/full/" + this.theGroup)
        .then(result => {
          this.waterChartData = result.data;
        }).catch(error => {
      console.log(error);
    });

    this.$http.get("metrics/vineyard/power/graph/" + this.theGroup)
        .then(result => {
          this.powerData = result.data;
        }).catch(error => {
      console.log(error);
    });

    this.$http.get("metrics/vineyard/gas/graph/" + this.theGroup)
        .then(result => {
          this.gasData = result.data;
        }).catch(error => {
      console.log(error);
    });


    this.$http.get("metrics/vineyard/fertilizer/graph/" + this.theGroup)
        .then(result => {
          this.fertilizerData = result.data;
        }).catch(error => {
      console.log(error);
    });
  },
  methods: {
    getNextDay: function (currentMonth) {

      let currentIndex = Date.shortMonths.indexOf(currentMonth);
      let offsetLength = Date.shortMonths.length - 1;
      if (currentIndex === offsetLength) {
        return Date.shortMonths[0];
      } else {
        return Date.shortMonths[currentIndex + 1];
      }
    },
    calculateMonthList: function () {
      let today = new Date(Date.now());

      let latestDate = new Date((today.getFullYear()), today.getMonth() + 1, 1);
      let earliestDate = new Date((today.getFullYear() - 3), today.getMonth(), 1);
      console.log("Latest Date: " + latestDate + " Earliest Date: " + earliestDate);
      let earliestMonth = earliestDate.getMonth();
      let earliestYear = earliestDate.getFullYear();
      let latestMonth = latestDate.getMonth();
      let latestYear = latestDate.getFullYear();
      let currentYear = parseInt(earliestYear.toString().substring(2));
      let latestYearShort = parseInt(latestYear.toString().substring(2));
      let theList = [];
      let counter = 0;
      let currentMonthName = Date.shortMonths[earliestMonth];
      let latestMonthName = Date.shortMonths[latestMonth];
      do {
        console.log("Doing the List Creating");
        theList.push(currentMonthName + "-" + currentYear);
        currentMonthName = this.getNextDay(currentMonthName);
        if (currentMonthName === Date.shortMonths[0]) {
          currentYear = currentYear + 1;
        }
        //To insure we don't have a runaway loop.
        counter++;
        if (counter === 40) {
          console.log("Break Loop");
          break;
        }
      } while (currentMonthName !== latestMonthName || currentYear !== latestYearShort);
      return theList;
    },
    calculateMaxChartYValue: function (data, fieldName) {
      let max = 1000;
      if (data && Array.isArray(data)) {
        data.forEach(val => {
          if (val[fieldName] > max) {
            max = Math.floor(val[fieldName] * 1.10);
          }
        });
      }
      console.log(`${fieldName} Max:  + ${max}`);
      return max;
    },
    addHeaders(data) {
      let theData = [['Month', 'Winery Process', 'Tasting/Offices', 'Landscaping']];
      data.forEach(function (element) {
        theData.push([element.meterUsage, element.wineryProcess, element.tastingOffices, element.landscaping])
      });
      return theData;
    },
    padValues: function (headers) {
      let theData = [headers];
      this.fullMonthList.forEach(function (month) {
        theData.push([month, 0]);
      });
      return theData;
    },
    addIrrigationHeaders(data) {
      let self = this;
      let theData = this.padValues(['Month', 'Irrigation']);
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element);
        if (shouldAddToGraph === true) {
          let item = theData.find(val => val[0] === element.meterUsage);
          item[1] = element.irrigation;
        }
      });
      if (theData.length === 1) {
        theData.push(['', 0]);
      }
      return theData;
    },
    addTastingHeaders(data) {
      let self = this;
      let theData = this.padValues(['Month', 'Other']);
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element);
        if (shouldAddToGraph === true) {
          let item = theData.find(val => val[0] === element.meterUsage);
          item[1] = element.other;
        }
      });
      return theData;
    },
    addFrostHeaders(data) {
      let self = this;
      let theData = this.padValues(['Month', 'Landscaping']);
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element);
        if (shouldAddToGraph === true) {
          let item = theData.find(val => val[0] === element.meterUsage);
          item[1] = element.frost;
        }
      });
      return theData;
    },
    addOther2Headers(data) {
      let self = this;
      let theData = this.padValues(['Month', 'Other2']);
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element);
        if (shouldAddToGraph === true) {
          let item = theData.find(val => val[0] === element.meterUsage);
          item[1] = element.other2;
        }
      });
      return theData;
    },
    addSolarHeaders(data) {
      let self = this;
      let theData = this.padValues(['Month', 'Solar Productivity']);
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element);
        if (shouldAddToGraph === true) {
          let item = theData.find(val => val[0] === element.meterUsage);
          item[1] = element.solar;
        }
      });
      return theData;
    },
    addElectricMeter1Headers(data) {
      let self = this;
      let theData = this.padValues(['Month', 'Ag Meter 1']);
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element);
        if (shouldAddToGraph === true) {
          let item = theData.find(val => val[0] === element.meterUsage);
          item[1] = element.ag1;
        }
      });

      return theData;
    },
    addElectricMeter2Headers(data) {
      let self = this;
      let theData = this.padValues(['Month', 'Ag Meter 2']);
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element);
        if (shouldAddToGraph === true) {
          let item = theData.find(val => val[0] === element.meterUsage);
          item[1] = element.ag2;
        }
      });
      return theData;
    },
    calculateIsMonthVisible: function (element) {
      let today = new Date(Date.now());
      let year = Number.parseInt(element.meterUsage.split("-")[1], 10) + 2000;
      let isBeforeLatestMonth;
      let isAfterEarliestMonth;
      let month = Date.shortMonths.indexOf(element.meterUsage.split("-")[0]);
      let dateToCheck = new Date(year, month, 1);
      let latestDate = new Date((today.getFullYear()), today.getMonth() + 1, 1);
      let earliestDate = new Date((today.getFullYear() - 3), today.getMonth(), 1);
      isBeforeLatestMonth = latestDate.getTime() > dateToCheck.getTime();
      isAfterEarliestMonth = dateToCheck.getTime() > earliestDate.getTime();
      return isBeforeLatestMonth && isAfterEarliestMonth;
    },
    addElectricMeter3Headers(data) {
      let self = this;
      let theData = this.padValues(['Month', 'Ag Meter 3']);
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element, shouldAddToGraph);
        if (shouldAddToGraph === true) {
          let item = theData.find(val => val[0] === element.meterUsage);
          item[1] = element.ag3;
        }
      });
      return theData;
    },
    addGasHeaders(data) {
      let self = this;
      let theData = this.padValues(['Month', 'Gas']);
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element, shouldAddToGraph);
        if (shouldAddToGraph === true) {
          let item = theData.find(val => val[0] === element.meterUsage);
          item[1] = element.naturalGas;
        }
      });
      return theData;
    },
    addPropaneHeaders(data) {
      let self = this;
      let theData = this.padValues(['Month', 'Propane']);
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element, shouldAddToGraph);
        if (shouldAddToGraph === true) {
          let item = theData.find(val => val[0] === element.meterUsage);
          item[1] = element.propane;
        }
      });
      return theData;
    },
    addGasolineHeaders(data) {
      let self = this;
      let theData = this.padValues(['Month', 'Gasoline']);
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element, shouldAddToGraph);
        if (shouldAddToGraph === true) {
          let item = theData.find(val => val[0] === element.meterUsage);
          if (item) {
            item[1] = element.gasoline;
          }
        }
      });
      return theData;
    },
    getSolarOptions(_year) {
      console.log("Getting Options");
      return {

        title: 'Vineyard Solar Usage - kWh/Month ',
        subtitle: 'Sales, Expenses, and Profit: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this.solarMax,
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: '#FFFF00'}
        }
      }
    },
    getElectricOptions(meterNumber, color) {
      console.log("Getting Options");
      let meterNumberString = meterNumber;// > 1 ? '' : meterNumber;
      return {

        title: 'Vineyard Electrical Meter ' + meterNumber + ' Usage - kWh/Month ',
        subtitle: 'Sales, Expenses, and Profit: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this[`ag${meterNumberString}Max`],
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: color}
        }
      }
    },
    getOptions(year) {
      console.log("Getting Options");
      return {

        title: 'Vineyard Electrical Usage - kWh/Month ' + year,
        subtitle: 'Sales, Expenses, and Profit: ' + year,
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight}
      }
    },
    getIrrigationOptions(_year) {
      console.log("Getting Options");
      let options = {

        title: 'Irrigation Water Usage - Gallons/Month ',
        subtitle: 'Sales, Expenses, and Profit: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this.processMax,
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: '#43459d'}
        }
      }
      console.log("Process Options");
      console.log(options);
      return options;
    },
    getTastingOptions(_year) {
      console.log("Getting Options");
      return {

        title: 'Other Usage - Gallons/Month ',
        subtitle: 'Sales, Expenses, and Profit: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this.otherMax,
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: '#ADD8E6'}
        }
      }
    },
    getOther2Options(_year) {
      console.log("Getting Options");
      return {

        title: 'Other 2 Usage - Gallons/Month ',
        subtitle: 'Sales, Expenses, and Profit: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this.other2Max,
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: '#7df9ff'}
        }
      }
    },
    getFrostOptions(_year) {
      console.log("Getting Options");
      return {

        title: 'Frost Water Usage - Gallons/Month ',
        subtitle: 'Sales, Expenses, and Profit: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this.frostMax,
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: 'green'}
        }
      }
    },
    getNaturalGasOptions(color) {
      console.log("Getting Options");
      return {

        title: 'Natural Gas Usage - Therms/Month ',
        subtitle: 'Natural Gas Used: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this.naturalGasMax,
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: color}
        }
      }
    },
    getPropaneOptions(_year, color) {
      console.log("Getting Propane Options");
      return {

        title: 'Propane Usage - Gallons/Month ',
        subtitle: 'Propane Used: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this.propaneMax,
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: color}
        }
      }
    },
    getGasolineOptions(_year, color) {
      console.log("Getting Gasoline Options");
      return {

        title: 'Gasoline Usage - Gallons/Month ',
        subtitle: 'Gasoline Used: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this.gasolineMax,
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: color}
        }
      }
    },
    addHeadersDynamic(data, columnHeaderName, valueFieldName) {
      let self = this;
      let theData = this.padValues(['Month', columnHeaderName]);
      data.forEach(function (element) {
        let shouldAddToGraph = self.calculateIsMonthVisible(element, shouldAddToGraph);
        if (shouldAddToGraph === true) {
          let item = theData.find(val => val[0] === element.meterUsage);
          if (item) {
            item[1] = element[valueFieldName];
          }
        }
      });
      return theData;
    },
    getDynamicOptions(title, color, fieldName) {
      console.log("Getting Gasoline Options");
      return {

        title: title,
        subtitle: 'Quantity Used: ',
        pointsVisible: true,
        chartArea: {width: this.chartWidth, height: this.chartHeight},
        vAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            max: this[`${fieldName}Max`],
            min: 0
          }
        },
        height: this.chartWrapperHeight,
        width: this.chartWrapperWidth,
        series: {
          0: {color: color}
        }
      }
    },
  }
}
</script>

<style scoped>
.chart {
  width: 100%;
  min-height: 700px;
}

.rect {
  width: 100%;
}

.row {
  margin: 0 !important;
}
</style>
